// IMPORTANT: Please remember to update this file whenever a new feature flag is added.
// Add the new feature flag as a constant by defining it here and include it in the featureFlags array below.
// Also, make sure to remove any feature flags from this file that are no longer being used in the code.

export const MILESTONE_IMPROVED_SIGNUP_ENABLED = 'MILESTONE_IMPROVED_SIGNUP_ENABLED';
export const MILESTONE_ONE_FEED_ENABLED = 'MILESTONE_ONE_FEED_ENABLED';
export const MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED = 'MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED';
export const MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED = 'MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED';
export const FEATURE_NEW_TRANSCRIPT_PDF_ENABLED = 'FEATURE_NEW_TRANSCRIPT_PDF_ENABLED';
export const FEATURE_NEW_SR_CERTIFICATE_PDF_ENABLED = 'FEATURE_NEW_SR_CERTIFICATE_PDF_ENABLED';
export const MILESTONE_USERS_CAN_PAY_FOR_A_PRO_PLAN_ENABLED = 'MILESTONE_USERS_CAN_PAY_FOR_A_PRO_PLAN_ENABLED';
export const FEAT_TRACK_PROFILE_CHANGES_ENABLED = 'FEAT_TRACK_PROFILE_CHANGES_ENABLED';
export const FEAT_PRICING_PAGE_ENABLED = 'FEAT_PRICING_PAGE_ENABLED';

// Migration of pages using the new layout
export const MIGRATE_PAGE_MY_PLAN_ENABLED = 'MIGRATE_PAGE_MY_PLAN_ENABLED';
export const MIGRATE_PAGE_TOPICS_ENABLED = 'MIGRATE_PAGE_TOPICS_ENABLED';
export const MIGRATE_PAGE_MAIN_FEED_ENABLED = 'MIGRATE_PAGE_MAIN_FEED_ENABLED';
export const MIGRATE_PAGE_TOPIC_STATE_FEED_ENABLED = 'MIGRATE_PAGE_TOPIC_STATE_FEED_ENABLED';
export const MIGRATE_PAGE_TRANSCRIPT_ENABLED = 'MIGRATE_PAGE_TRANSCRIPT_ENABLED';
export const MIGRATE_PAGE_ARTICLE_ABSTRACT_ENABLED = 'MIGRATE_PAGE_ARTICLE_ABSTRACT_ENABLED';

// Migration of sections using the new text field
export const MIGRATE_TEXT_FIELD_AUTH_ENABLED = 'MIGRATE_TEXT_FIELD_AUTH_ENABLED';
export const MIGRATE_TEXT_FIELD_FEED_CUSTOMIZATION_ENABLED = 'MIGRATE_TEXT_FIELD_FEED_CUSTOMIZATION_ENABLED';
export const MIGRATE_TEXT_FIELD_SPECIAL_REQUIREMENTS_ENABLED = 'MIGRATE_TEXT_FIELD_SPECIAL_REQUIREMENTS_ENABLED';
export const MIGRATE_TEXT_FIELD_PROFILE_ENABLED = 'MIGRATE_TEXT_FIELD_PROFILE_ENABLED';
export const MIGRATE_TEXT_FIELD_PAYMENT_ENABLED = 'MIGRATE_TEXT_FIELD_PAYMENT_ENABLED';

// Every feature flag should be added to this array, to be considered by the feature flag service.
export const FEATURE_FLAGS = [
  MILESTONE_IMPROVED_SIGNUP_ENABLED,
  MILESTONE_ONE_FEED_ENABLED,
  MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED,
  MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED,
  FEATURE_NEW_TRANSCRIPT_PDF_ENABLED,
  FEATURE_NEW_SR_CERTIFICATE_PDF_ENABLED,
  MILESTONE_USERS_CAN_PAY_FOR_A_PRO_PLAN_ENABLED,
  MIGRATE_TEXT_FIELD_AUTH_ENABLED,
  MIGRATE_TEXT_FIELD_FEED_CUSTOMIZATION_ENABLED,
  MIGRATE_TEXT_FIELD_SPECIAL_REQUIREMENTS_ENABLED,
  MIGRATE_TEXT_FIELD_PROFILE_ENABLED,
  MIGRATE_TEXT_FIELD_PAYMENT_ENABLED,
  FEAT_TRACK_PROFILE_CHANGES_ENABLED,
  FEAT_PRICING_PAGE_ENABLED
];

// These feature flags are always off, regardless of the feature flag service status.
export const DISABLED_FEATURE_FLAGS = [
  MILESTONE_IMPROVED_SIGNUP_ENABLED,
  MILESTONE_ONE_FEED_ENABLED,
  // Until release 18
  MIGRATE_TEXT_FIELD_AUTH_ENABLED,
  MIGRATE_TEXT_FIELD_PROFILE_ENABLED,
];

// These feature flags are always on, regardless of the feature flag service status.
export const ALWAYS_ON_FEATURE_FLAGS = [
  MIGRATE_PAGE_MY_PLAN_ENABLED,
  MIGRATE_PAGE_TOPICS_ENABLED,
  MIGRATE_PAGE_MAIN_FEED_ENABLED,
  MIGRATE_PAGE_TOPIC_STATE_FEED_ENABLED,
  // missing component and test failed because of that
  // MIGRATE_PAGE_TRANSCRIPT_ENABLED
  MIGRATE_PAGE_ARTICLE_ABSTRACT_ENABLED,
];
